import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { classicAppUrl } from '../utils/origins';

const NAV = [
  { to: '/about', label: 'About' },
  { to: '/blog', label: 'Blog' },
  { to: '/careers', label: 'Careers' },
  { to: '/case-studies', label: 'Stories' },
  { to: '/pricing', label: 'Pricing' },
];

export default function MarketingShell({ children, title, description }) {
  const location = useLocation();
  const search = location.search || '';

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="border-b border-gray-100 bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-6 py-4">
          <Link to="/" className="text-sm font-semibold tracking-tight text-gray-900">
            Upgraded
          </Link>
          <nav className="hidden items-center gap-5 sm:flex">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={`${item.to}${search}`}
                className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
              >
                {item.label}
              </Link>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <a
              href={classicAppUrl('/sign-in', search)}
              className="hidden text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors sm:inline"
            >
              Classic app
            </a>
            <Link
              to={`/sign-in${search}`}
              className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
            >
              Sign in
            </Link>
            <Link
              to={`/sign-up${search}`}
              className="inline-flex items-center rounded-lg bg-gray-900 px-3 py-1.5 text-xs font-medium text-white hover:bg-gray-800 transition-colors"
            >
              Sign up
            </Link>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-6 py-10">
        {title ? (
          <div className="mb-8 space-y-2">
            <h1 className="text-xl font-semibold tracking-tight text-gray-900">{title}</h1>
            {description ? <p className="text-sm text-gray-600">{description}</p> : null}
          </div>
        ) : null}
        {children}
      </main>
    </div>
  );
}
